import { FiTrendingUp, FiDollarSign, FiCompass,FiCommand, FiBox, FiCamera, FiBell, FiMonitor } from '../assets/icons/vander'
import client1 from '../assets/images/team/01.jpg'
import client2 from '../assets/images/team/02.jpg'
import client3 from '../assets/images/team/03.jpg'
import client4 from '../assets/images/team/04.jpg'
import client5 from '../assets/images/team/05.jpg'
import client6 from '../assets/images/team/06.jpg'

import blog1 from '../assets/images/blog/ma.jpg'
import blog2 from '../assets/images/blog/9.jpeg'
import blog3 from '../assets/images/blog/10.jpg'
import blog4 from '../assets/images/solar/kah.webp'
import company1 from '../assets/images/team/amazon.svg'
import company2 from '../assets/images/team/google.svg'
import company3 from '../assets/images/team/lenovo.svg'
import company4 from '../assets/images/team/paypal.svg'
import company5 from '../assets/images/team/shopify.svg'
import company6 from '../assets/images/team/spotify.svg'

export const PHOTOVOLTAIC = [
    {
        icon: FiTrendingUp,
        title: 'Off-Grid',
        desc: 'Solar Power Home System, Solar Streel Lights, Solar Irrigation System, Solar Backup Systems, Solar Cooling, Solar Pumping System, and Solar Charging Stations.'
    },
    {
        icon: FiTrendingUp,
        title: 'On-Grid',
        desc: 'Grid-Connected Solar Power System, Straight Backup System, Rooftop Solar Power Systems, Solar Power for Homes, Solar Office Installations, and Solar Power Plants.'
    },
    {
        icon: FiTrendingUp,
        title: 'Services',
        desc: 'Supply of Solar Equipment, Maintenance, Training, Consultancy, Project Management, System Installation, and Solar Solutions Design Services.'
    }
];


export const REALESTATE = [
    {
        icon: FiBox,
        title: 'Designing and Planning',
        desc: 'We create innovative and sustainable designs for green buildings.'
    },
    {
        icon: FiBox,
        title: 'Construction of Green Buildings',
        desc: 'We ensure eco-friendly methods in building construction projects.'
    },
    {
        icon: FiBox,
        title: 'Building Automation',
        desc: 'We offer smart automation solutions for efficient building control.'
    }
    
   
  
]

export const EMOBILITY = [
    {
        icon: FiCommand,
        title: 'Grow Your Business',
        desc: 'Empowering businesses with innovative e-mobility solutions for growth and sustainability in the transportation industry.'
    },
    {
        icon: FiCommand,
        title: 'Domestic Charger',
        desc: 'Providing reliable and efficient home charging solutions for electric vehicles to ensure convenience and ease of use.'
    },
    {
        icon: FiCommand,
        title: 'Consultancy',
        desc: 'Offering expert guidance and strategic advice on e-mobility solutions tailored to meet individual and organizational needs.'
    }
];


export const clientData = [
    {
        image:client1,
        name:'Calvin Carlo',
        title:'Manager',
        desc:'" It seems that only fragments of the original text remain in the Lorem Ipsum texts used today. "'
    },
    {
        image:client2,
        name:'Christa Smith',
        title:'Manager',
        desc:'" The most well-known dummy text is the Lorem Ipsum, which is said to have originated in the 16th century. "'
    },
    {
        image:client3,
        name:'Jemina CLone',
        title:'Manager',
        desc:'" One disadvantage of Lorum Ipsum is that in Latin certain letters appear more frequently than others"'
    },
    {
        image:client4,
        name:'Smith Vodka',
        title:'Manager',
        desc:'" Thus, Lorem Ipsum has only limited suitability as a visual filler for German texts "'
    },
    {
        image:client5,
        name:'Cristino Murfi',
        title:'Manager',
        desc:'" There is now an abundance of readable dummy texts. These are usually used when a text is required"'
    },
    {
        image:client6,
        name:'Cristino Murfi',
        title:'Manager',
        desc:'" According to most sources, Lorum Ipsum can be traced back to a text composed by Cicero "'
    },
]

export const blogData = [
    {
        image:blog1,
        title:'Rwanda: 25kWp Solar Power System Installation at Ma Campagne Resort Muhazi',
        
    },
    {
        image:blog2,
        title:'Tchad: 100kWp Solar power system Installation at Fada Hospital',
       
    },
    {
        image:blog3,
        title:'Kenya: 515kWp Solar power system for UN office Gigili, Nairobi ',
       
    },
    {
        image:blog4,
        title:'Rwanda: Solar water pumping system of 75kWp at Kirehe District',
       
    },
]

export const companyLogo = [company1, company2, company3, company4, company5, company6]